import { DateTime } from 'luxon'
import toast from 'react-hot-toast'
const monthArray = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export const todayDate = () => {
  const today = DateTime.now()
  return today.toFormat('yyyy-MM-dd')
}

export const prevDates = (
  date: string,
  days: number,
  groupCreationDate: string
) => {
  const last = new Date(new Date(date).getTime() - days * 24 * 60 * 60 * 1000)
  const day = last.getDate().toString()
  const month = (last.getMonth() + 1).toString()
  const year = last.getFullYear().toString()
  const result = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

  if (new Date(result) < new Date(groupCreationDate)) {
    toast.error(`Can't Go Behind ${groupCreationDate}`)
    return groupCreationDate
  }
  return result
}

export const nextDates = (date: string, days: number) => {
  const today_date = todayDate()
  const last = new Date(new Date(date).getTime() + days * 24 * 60 * 60 * 1000)
  const day = last.getDate().toString()
  const month = (last.getMonth() + 1).toString()
  const year = last.getFullYear().toString()
  const result = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

  if (new Date(today_date) < new Date(result)) {
    toast.error("Can't Exceed Today's Date")
    return today_date
  }

  return result
}

export const startOfWeek = (date: Date) => {
  // Mon - Sun
  const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1)
  return new Date(date.setDate(diff))
}

export const isEqualStartWeekDate = (d1: Date, d2: Date) => {
  const date1 = startOfWeek(d1)
  const date2 = startOfWeek(d2)

  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  )
}

export const formatToDDMonthYear = (date: string) => {
  const dateArray = date.split('-')
  if (!date || dateArray.length !== 3) return date

  const month = monthArray[parseInt(dateArray[1])]

  return `${dateArray[2].padStart(2, '0')} ${month} ${dateArray[0]}`
}
